import { useEffect, useState } from "react";
import axios from "axios";

import Menu from "./Menu";

const HeaderMenu = () => {
	const [menus, setMenus] = useState([]);

	useEffect(() => {
		// we don't want to keep every menu
		let menuArray = [];

		axios
			.get("/wp-json/fords/v1/menus")
			.then((res) => {
				// filter menus and keep the ones that start with "mm" (mega menu)
				Object.keys(res.data).filter((slug) => {
					if (slug.startsWith("mm-")) {
						menuArray.push(res.data[slug]);
					}
				});
				return menuArray;
			})
			.then((res) => {
				setMenus(res);
			});
	}, []);

	const renderMenus = () => {
		if (!menus || !menus.length) return null;
		return menus.map((menu, index) => {
			const key = Object.keys(menu)[0];
			const isFirstHeading = index === 0;
			return <Menu key={key} menuObj={menu} isFirstHeading={isFirstHeading} />;
		});
	};

	return <div className="main-menu__wrap">{renderMenus()}</div>;
};

export default HeaderMenu;
